module.exports = __webpack_public_path__ + "cdbd880ed1e05ec5885c41f9fbea5b09.MP3";